var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreGoogle = function SvgStoreGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D252D",
    fillRule: "evenodd",
    d: "m26.957 23.535-3.195-3.195 3.345-3.346 2.916 1.684c1.188.686 1.188 2.4 0 3.087zm-.958.553-2.993-2.992-9.447 9.447a1.76 1.76 0 0 0 1.493-.135zM12.7 29.89l9.55-9.55-9.642-9.642c-.145.255-.23.553-.23.88v17.287c0 .391.122.74.322 1.025m.692-19.92c.5-.24 1.112-.252 1.66.064l11.097 6.407-3.143 3.143z",
    clipRule: "evenodd"
  })));
};
export default SvgStoreGoogle;